export const VIEW_THREAD = 'View thread';
